import * as React from 'react';

import Confirm from '@/components/layouts/Modal/BetPanel/Partials/TicketBox/Singlerace/CollapseList/Confirm';
import Ready from '@/components/layouts/Modal/BetPanel/Partials/TicketBox/Singlerace/CollapseList/Ready';
import { BetDetail, OddsData, OrderStep } from '@/modelTypes';

interface CollapseListProps {
  betDetail: BetDetail;
  orderStep: OrderStep;
  oddsData: OddsData;
  hashKey: string;
  changeCount: (
    value: number,
    itemId: string,
    setNum?: number | undefined,
  ) => void;
  deleteTicket: (itemId: string, setNum?: number | undefined) => void;
  setOpenList: React.Dispatch<React.SetStateAction<string[]>>;
}

const CollapseList: React.FC<CollapseListProps> = props => {
  const { orderStep } = props;

  return (
    <>
      {orderStep === OrderStep.Ready && <Ready {...props} />}
      {orderStep === OrderStep.Confirm && <Confirm {...props} />}
    </>
  );
};

export default CollapseList;
